
import { ApiTags, rootApi } from "../../../../services/rootApi"
import { IExamSchedule } from "./examSchedule"

const TAG = ApiTags.ServiceRequest;
const getTags = (entities: IExamSchedule[]) => [
  ...entities.map((p) => ({ type: TAG, id: p.id })),
  { type: TAG, id: "LIST" },
]

export const examScheduleApi = rootApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getExamSchedules: builder.query<IExamSchedule[], string>({
      query: (contactId) => `/Schedule/${contactId}`,
      providesTags: (result) => (result ? getTags(result) : [{ type: TAG, id: "LIST" }]),
      transformResponse: (response: any): IExamSchedule[] => {
        console.log("🟢 Raw Exam Schedule API Response:", response)

        // Map and format data properly
        return response.map((item: any) => ({
          id: item.id,
          name: item.name ?? "N/A",
          courseName: item.courseName ?? "N/A",
          courseId: item.courseId ?? "N/A",
          startDate: item.startDate ?? "N/A",
          endDate: item.endDate ?? "N/A",
          isPublished: item.isPublished ?? "N/A",
        }))
      },
    }),
  }),
})

export const { useGetExamSchedulesQuery, useLazyGetExamSchedulesQuery } = examScheduleApi
